import { Component } from '@theme/component';
import { CartLinesUpdateEvent } from '@shopify/events';

class CartUpgradeComponent extends Component {

  connectedCallback() {
    super.connectedCallback();

    this.button = this.querySelector('.cart-upgrade-button');

    if (!this.button) return;

    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  onClick = async (event) => {
  event.preventDefault();

  this.button.disabled = true;
  this.button.textContent = 'ADDING...';

  const itemKey = this.dataset.itemKey;
  const bundleVariant = Number(this.dataset.bundleVariant);

  try {

  const cartItemsComponents = document.querySelectorAll('cart-items-component');

const sectionIds = [];

cartItemsComponents.forEach((component) => {
  if (component.dataset.sectionId) {
    sectionIds.push(component.dataset.sectionId);
  }
});

const deferred = CartLinesUpdateEvent.createPromise();

this.dispatchEvent(
  new CartLinesUpdateEvent({
    action: 'add',
    context: 'upgrade',
    lines: [
      {
        merchandiseId: String(bundleVariant),
        quantity: 1,
      },
    ],
    promise: deferred.promise,
  })
);

// Remove existing item
await fetch(Theme.routes.cart_change_url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  body: JSON.stringify({
    id: itemKey,
    quantity: 0,
    sections: sectionIds.join(','),
    sections_url: window.location.pathname,
  }),
});

// Add bundle
const addResponse = await fetch(Theme.routes.cart_add_url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  body: JSON.stringify({
    items: [
      {
        id: bundleVariant,
        quantity: 1,
      },
    ],
    sections: sectionIds.join(','),
    sections_url: window.location.pathname,
  }),
}).then((r) => r.json());

// Fetch latest cart
const ajaxCart = await fetch(`${Theme.routes.cart_url}.json`, {
  headers: {
    Accept: 'application/json',
  },
}).then((r) => r.json());

// THIS is what ProductForm does
deferred.resolve({
  cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
  detail: {
    items: ajaxCart.items,
    source: 'cart-upgrade-component',
    sourceId: this.id,
    itemCount: 1,
    sections: addResponse.sections,
    didError: false,
  },
});

this.button.textContent = '✓ ADDED';

setTimeout(() => {
  this.button.disabled = false;
  this.button.textContent = 'COMPLETE SET';
}, 1000);
  } catch (error) {
    console.error(error);

    alert(error.message);

    this.button.disabled = false;
    this.button.textContent = 'COMPLETE SET';
  }
};

}

if (!customElements.get('cart-upgrade-component')) {
  customElements.define(
    'cart-upgrade-component',
    CartUpgradeComponent
  );
}